import obj from "./obj";

const isFiltered = (filters: any) => {
  if (!filters) {
    return false;
  }

  if (obj.isEmpty(filters)) {
    return false;
  }

  if (Object.values(filters).every((e) => !e)) {
    return false;
  }

  return true;
};

export default { isFiltered };
